import { get } from "lodash";

export default class Company {
  id?: string;
  name: string;
  legalName: string;
  businessName: string;
  language: string;
  country: string;
  rut?: string;
  address?: string;

  constructor(params?: Company) {
    this.id = get(params, "id", undefined);
    this.name = get(params, "name", "");
    this.legalName = get(params, "legalName", "");
    this.businessName = get(params, "businessName", "");
    this.language = get(params, "language", "");
    this.country = get(params, "country", "");
    this.rut = get(params, "rut", "");
    this.address = get(params, "address", "");
  }
}
